module.exports = __webpack_public_path__ + "static/1-herramientas-f4953bdddd0c3b03f3b0d7d9fa1d51a0.jpg";